import SelectDropDown from 'components/SelectDropDown/SelectDropDown';
import { Title } from 'components/Title/Title';
import { checkIntegrationData } from 'helper/Integration';
import { inject, observer } from 'mobx-react';
import { INTEGRATION } from 'models/Integration';
import React, { useEffect, useState } from 'react';
import { AworkIntegrationStore } from 'stores/integrations/AworkIntegrationStore';
import { ProjectStore } from 'stores/private/ProjectStore';

interface AworkConfigurationProps {
  integrationID: string;
  index: number;
  aworkIntegrationStore?: AworkIntegrationStore;
  projectStore?: ProjectStore;
  onChange: (data: any) => any;
}

const AworkConfiguration = ({
  integrationID,
  index,
  aworkIntegrationStore,
  projectStore,
  onChange,
}: AworkConfigurationProps) => {
  const project = projectStore?.currentProject;

  const [currentIntegrationInfo, setCurrentIntegrationInfo] = useState(
    {} as any,
  );

  const [boardID, setBoardID] = useState('');
  const [statusID, setStatusID] = useState('');
  const [typeOfWorkID, setTypeOfWorkID] = useState('');

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);

  useEffect(() => {
    if (project && isMounted) {
      initialize();
    }
  }, [project, isMounted]);

  useEffect(() => {
    saveIntegrationInfo();
  }, [boardID, statusID, typeOfWorkID]);

  const initialize = async () => {
    aworkIntegrationStore!.setIntegrationID(integrationID);
    if (
      projectStore?.currentProject &&
      projectStore?.currentProject.integrations &&
      projectStore?.currentProject.integrations.awork
    ) {
      aworkIntegrationStore!.setAccessToken(
        projectStore?.currentProject.integrations.awork[integrationID].authInfo
          .token,
      );
      loadBoard();
    }

    if (
      !checkIntegrationData({
        project,
        integrationName: INTEGRATION.AWORK,
        integrationID,
        actionIndex: index,
      })
    ) {
      return;
    }

    const integrationInfo =
      project?.integrations?.awork[integrationID]?.actions[index]
        ?.integrationInfo;

    setCurrentIntegrationInfo(integrationInfo);
  };

  const loadBoard = async () => {
    await aworkIntegrationStore!.getBoards();
    await aworkIntegrationStore!.getTypesOfWork();
  };

  const saveIntegrationInfo = () => {
    const integrationInfo = {
      boardID,
      statusID,
      typeOfWorkID,
    };

    onChange(integrationInfo);
  };

  return (
    <div className="configuration-container mt-30">
      <SelectDropDown
        className="mb-15"
        label="Select type of work"
        labelPropertyName="name"
        valuePropertyName="id"
        selectedItem={aworkIntegrationStore!.typesOfWork.find(
          (element) => element.id === currentIntegrationInfo?.typeOfWorkID,
        )}
        isLoading={aworkIntegrationStore!.typesOfWork.length === 0}
        items={aworkIntegrationStore!.typesOfWork}
        onChange={(option) => {
          setTypeOfWorkID(option.id);
        }}
      />
      {typeOfWorkID !== '' && (
        <SelectDropDown
          className="mb-15"
          label="Select project"
          labelPropertyName="name"
          valuePropertyName="id"
          selectedItem={aworkIntegrationStore!.boards.find(
            (element) => element.id === currentIntegrationInfo?.boardID,
          )}
          isLoading={aworkIntegrationStore!.boards.length === 0}
          items={aworkIntegrationStore!.boards}
          onChange={async (option) => {
            setBoardID(option.id);
            await aworkIntegrationStore!.getProjectStatuses(option.id);
          }}
        />
      )}
      {boardID !== '' && (
        <SelectDropDown
          className="mb-15"
          label="Select task status"
          labelPropertyName="name"
          valuePropertyName="id"
          selectedItem={aworkIntegrationStore!.statuses.find(
            (element) => element.id === currentIntegrationInfo?.statusID,
          )}
          isLoading={aworkIntegrationStore!.statuses === 0}
          items={aworkIntegrationStore!.statuses}
          onChange={(option) => {
            setStatusID(option.id);
          }}
        />
      )}
    </div>
  );
};

export default inject(
  'aworkIntegrationStore',
  'projectStore',
)(observer(AworkConfiguration));
